import { Badge } from '@/components/ui/badge';

/**
 * **LA PRÉSENCE EN LIGNE — UNE PERSONNE À LA FOIS, ET AUCUN AGRÉGAT.**
 *
 * F-59 : « **la présence en ligne se lit une personne à la fois, sur la liste et sur la fiche,
 * sans trace. AUCUN AGRÉGAT N'EXISTE** — pas de "douze personnes connectées". **Le lire agrégé
 * serait lire un état vivant par son agrégat**, ce que le corpus refuse déjà sur les
 * préférences. »
 *
 * §6.14 le porte en champ interdit, pour les deux rôles : « **tout agrégat** ». Et F-67 le
 * redit de l'autre côté : « **la présence en ligne n'est pas un chiffre et ne vit pas ici** :
 * elle se lit **une personne à la fois**. »
 *
 * **Ce composant ne peut donc pas compter**, et c'est pour cela qu'il ne reçoit qu'un état et
 * jamais une liste : un composant qui prendrait la liste serait à deux lignes de rendre
 * « 12 connectés ».
 *
 * **Trois valeurs, et il n'y en a pas d'autre.** Le contrat les fige, avec sa raison :
 * « **PERSONNE NE PEUT SE RENDRE INVISIBLE** : aucun mode indisponible, aucun masquage, aucune
 * exception. "occupe" vaut pour tout le monde, tuteur comme élève. »
 */
export function Presence({ etat }: { readonly etat: 'absent' | 'connecte' | 'occupe' }) {
  if (etat === 'connecte') return <Badge variant="default">en ligne</Badge>;
  if (etat === 'occupe') return <Badge variant="secondary">en cours</Badge>;
  return <Badge variant="outline">absent</Badge>;
}
